import { Ajax } from './axios'
export default {
  // 考试结果页的info数据
  GETresultPageBycollegeId(param = {}) {
    return Ajax.get(`/api/examinee/v1/exam/resultPage/${param.collegeId}`, {
      ...param
    })
  },
  POSTresultList(param = {}) {
    return Ajax.post(`/api/examinee/v1/exam/resultList`, { ...param })
  },
  // 考生科目成绩单详情
  POSTresultSubject(param = {}) {
    return Ajax.post(`/api/examinee/v1/exam/result/examineeList`, { ...param }, { headers: param.headers})
  },
  // 考生科目成绩单详情
  getExamResult(param = {}) {
    return Ajax.get(`/api/examinee/v5/exam/result/${param}`)
  },
}
